// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".b-contact-list{display:grid;grid-template-columns:repeat(1,minmax(0,1fr));grid-gap:3rem;gap:3rem}@media(min-width:1440px){.b-contact-list{grid-template-columns:repeat(2,minmax(0,1fr))}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
